import { BRANCHPARAM_LEAVEQUOTE } from '@/store/types'

export const leaveQuote = {
  data() {
    return {
      routeTo: undefined,
      skipPrompt: false,
      promptLeave: false
    }
  },
  methods: {
    doExit() {
      try {
        this.skipPrompt = true
        if (this.routeTo.name === 'branchReview') {
          this.$router.push({ name: 'branchReview', params: { brn: 'new' } })
        } else {
          this.$router.push(this.routeTo.path)
        }
      } catch (e) { }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.newDri) {
      next()
    } else {
      if (this.skipPrompt) {
        next()
      } else {
        if (this.$store.state.branchParam.promptWhenExit) {
          this.routeTo = to
          this.promptLeave = true
          next(false)
        } else {
          this.$store.commit(BRANCHPARAM_LEAVEQUOTE, true)
          next()
        }
      }
    }
  },
  created() {
    this.$root.$on('leaveQuote', () => {
      this.doExit()
    })
  },
  beforeDestroy() {
    this.$root.$off('leaveQuote')
  }
}
